module.exports = __webpack_public_path__ + "media/images/v2/meeting_blue-b984b5ab585a0971f53521e5d0c76aa1.png";